/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lang_Suggestion_LabelInputs */

const en_lang_suggestion_label = /** @type {(inputs: Lang_Suggestion_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language suggestion`)
};

const ar_lang_suggestion_label = /** @type {(inputs: Lang_Suggestion_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اقتراح اللغة`)
};

const bn_lang_suggestion_label = /** @type {(inputs: Lang_Suggestion_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ভাষার পরামর্শ`)
};

const de_lang_suggestion_label = /** @type {(inputs: Lang_Suggestion_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprachvorschlag`)
};

const es_lang_suggestion_label = /** @type {(inputs: Lang_Suggestion_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugerencia de idioma`)
};

const fr_lang_suggestion_label = /** @type {(inputs: Lang_Suggestion_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestion de langue`)
};

const pt_lang_suggestion_label = /** @type {(inputs: Lang_Suggestion_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugestão de idioma`)
};

const zh_lang_suggestion_label = /** @type {(inputs: Lang_Suggestion_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`语言建议`)
};

const tr_lang_suggestion_label = /** @type {(inputs: Lang_Suggestion_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dil önerisi`)
};

const ru_lang_suggestion_label = /** @type {(inputs: Lang_Suggestion_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предложение языка`)
};

const pl_lang_suggestion_label = /** @type {(inputs: Lang_Suggestion_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugestia języka`)
};

/**
* | output |
* | --- |
* | "Language suggestion" |
*
* @param {Lang_Suggestion_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const lang_suggestion_label = /** @type {((inputs?: Lang_Suggestion_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lang_Suggestion_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_lang_suggestion_label(inputs)
	if (locale === "bn") return bn_lang_suggestion_label(inputs)
	if (locale === "de") return de_lang_suggestion_label(inputs)
	if (locale === "es") return es_lang_suggestion_label(inputs)
	if (locale === "fr") return fr_lang_suggestion_label(inputs)
	if (locale === "pt") return pt_lang_suggestion_label(inputs)
	if (locale === "zh") return zh_lang_suggestion_label(inputs)
	if (locale === "tr") return tr_lang_suggestion_label(inputs)
	if (locale === "ru") return ru_lang_suggestion_label(inputs)
	if (locale === "pl") return pl_lang_suggestion_label(inputs)
	return en_lang_suggestion_label(inputs)
});